import { render, staticRenderFns } from "./LocalGroupEdit.vue?vue&type=template&id=afe70a16&scoped=true"
import script from "./LocalGroupEdit.vue?vue&type=script&lang=js"
export * from "./LocalGroupEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afe70a16",
  null
  
)

export default component.exports